import i18nConfigs from '../../i18n/config.json'
import type { Direction } from '../types'
import queryString from 'query-string'
import { getImage } from 'gatsby-plugin-image'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
import * as OtherIcons from 'components/Icons/Icons'
interface DownloadedFileNode {
    name: string
    absolutePath: string
    fileContent: string // Assuming content is a JSON string
}

let googleImages,
    googleFiles,
    forms,
    location,
    customers,
    tutorials,
    tutorialsRecent,
    blogs,
    tutorialsCategories,
    tutorialsPopular,
    documentations = []
function nextLevelPropExtractor(allProps, parentKey) {
    let currentLevelTitleProp = {}
    let nextLevelProp = []
    let nextLevelPropKey, currentLevelTitlePropKey
    const nextLevelPropsArray = []
    if (parentKey) {
        nextLevelProp = allProps
        nextLevelPropKey = parentKey
    } else {
        for (const key of Object.keys(allProps)) {
            // if (
            //     key.includes(`allHomeHero`) ||
            //     key.includes(`darkMode`) ||
            //     key.includes(`featuredTutorial`) ||
            //     key.includes(`hideAnchor`) ||
            //     key.includes(`showTitle`) ||
            //     key.includes(`showSidebar`) ||
            //     key.includes(`noindex`) ||
            //     key.includes(`published`) ||
            //     key.includes(`enableStarUsBanner`) ||
            //     key.includes(`page`) ||
            //     key.includes(`exclude`)
            // ) {
            //     props[key] = props[key]?.toLowerCase?.() === 'true'
            // }
            if (key.endsWith(`Title`)) {
                currentLevelTitleProp = allProps[key]
                currentLevelTitlePropKey = key
            }
            if (
                key.includes(`features`) ||
                key.includes(`quickContactProps`) ||
                key.includes(`sidebars`) ||
                key.includes(`plans`) ||
                key.includes(`callouts`) ||
                key.includes(`authors`) ||
                key.includes(`right`) ||
                key.includes(`discounts`) ||
                key.includes(`editions`) ||
                key.includes(`packages`) ||
                key.includes(`left`) ||
                key.includes(`subitems`) ||
                key.includes(`headers`) ||
                key.includes(`filters`) ||
                key.includes(`rows`) ||
                key.includes(`faqs`) ||
                key.includes(`descriptions`) ||
                key.includes(`options`) ||
                key.includes(`linkList`) ||
                key.includes(`formFields`) ||
                key.includes(`socialList`) ||
                key.includes(`tosPrivacyList`) ||
                key.includes(`products`) ||
                key.includes(`sections`) ||
                key.includes(`items`) ||
                key.includes(`links`) ||
                key.includes(`cards`) ||
                key.includes(`markets`) ||
                key.includes(`footers`) ||
                key.includes(`featuresGroup`) ||
                key.includes(`products`) ||
                key.includes(`ctas`)
            ) {
                nextLevelProp = allProps[key]
                nextLevelPropKey = key
                nextLevelPropsArray.push({ nextLevelPropKey: nextLevelPropKey, nextLevelProp: nextLevelProp })
            }
        }
    }

    return { nextLevelPropsArray, nextLevelProp, nextLevelPropKey, currentLevelTitleProp, currentLevelTitlePropKey }
}
function titlePropTransformer(titleProp, i18n) {
    if (Array.isArray(titleProp) && titleProp?.length == 1) {
        titleProp = titleProp[0]
    }
    if (titleProp && i18n.language === 'ar') {
        titleProp.text = titleProp?.text_ar
        titleProp.placeholder = titleProp?.placeholder_ar
        titleProp.content = titleProp?.content_ar
        titleProp.name = titleProp.name_ar
        titleProp.title = titleProp.title_ar
        titleProp.subtitle = titleProp.subtitle_ar
        titleProp.description = titleProp.description_ar
        titleProp.tag = titleProp.tag_ar
    }
    return titleProp
}
export function basicTransformer(allProps, i18n, reduce, targetLang) {
    if (Array.isArray(allProps) && allProps?.length == 1 && reduce) {
        allProps = allProps[0]
    }
    let languageInScope
    if (Array.isArray(allProps.i18) && allProps.i18?.length > 0) {
        languageInScope = allProps.i18.filter((lang) => {
            if (lang == (targetLang || i18n.language)) return lang
        })[0]
        if (!languageInScope) allProps.enable_ar = 'false'
        // console.log(
        //     `extract languageInScope value${languageInScope} prop allProps.i18 ${JSON.stringify(
        //         allProps.i18
        //     )} now allProps.enable ${allProps.enable}`
        // )
    }
    if (Array.isArray(allProps)) {
        allProps = allProps.filter((feature) => {
            if (!feature.enable || feature.enable != 'false') return feature
        })
    }
    allProps.customers = allProps.customers || customers
    allProps.blogs = allProps.blogs || blogs
    allProps.documentations = allProps.documentations || documentations
    allProps.tutorials = allProps.tutorials || tutorials
    allProps.tutorialsRecent = allProps.tutorialsRecent || tutorialsRecent
    allProps.tutorialsCategories = allProps.tutorialsCategories || tutorialsCategories
    allProps.tutorialsPopular = allProps.tutorialsPopular || tutorialsPopular
    allProps.className = allProps.className || ''
    allProps.align = allProps.align || ''
    // Store original values before making any changes
    if (!allProps.original) {
        allProps.original = {
            img: allProps.img,
        }
    }
    if (allProps && i18n.language === 'ar' && allProps.direction != 'rtl') {
        allProps.name_en = allProps.name
        allProps.text_en = allProps?.text
        allProps.placeholder_en = allProps?.placeholder
        allProps.text2_en = allProps?.text2
        allProps.text3_en = allProps?.text3
        allProps.text4_en = allProps?.text4
        allProps.content_en = allProps?.content
        allProps.title_en = allProps.title
        allProps.subtitle_en = allProps.subtitle
        allProps.tag_en = allProps.tag
        allProps.description_en = allProps.description
        allProps.q_en = allProps.q
        allProps.a_en = allProps.a
        if (allProps?.name_ar && allProps.name_ar != '') allProps.name = allProps?.name_ar
        if (allProps?.text_ar && allProps.text_ar != '') allProps.text = allProps?.text_ar
        if (allProps?.placeholder_ar && allProps.placeholder_ar != '') allProps.placeholder = allProps?.placeholder_ar
        if (allProps?.text2_ar && allProps.text2_ar != '') allProps.text2 = allProps?.text2_ar
        if (allProps?.text3_ar && allProps.text3_ar != '') allProps.text3 = allProps?.text3_ar
        if (allProps?.text4_ar && allProps.text4_ar != '') allProps.text4 = allProps?.text4_ar
        if (allProps?.content_ar && allProps.content_ar != '') allProps.content = allProps?.content_ar
        if (allProps?.title_ar && allProps.title_ar != '') allProps.title = allProps?.title_ar
        if (allProps?.subtitle_ar && allProps.subtitle_ar != '') allProps.subtitle = allProps?.subtitle_ar
        if (allProps?.tag_ar && allProps.tag_ar != '') allProps.tag = allProps?.tag_ar
        if (allProps?.description_ar && allProps.description_ar != '') allProps.description = allProps?.description_ar
        if (allProps?.a_ar && allProps.a_ar != '') allProps.a = allProps?.a_ar
        if (allProps?.q_ar && allProps.q_ar != '') allProps.q = allProps?.q_ar
        if (allProps?.img_ar) {
            allProps.img = allProps.img_ar
        }
        allProps.direction = 'rtl'
    }
    if (allProps && i18n.language === 'en') {
        if (allProps?.name_en && allProps.name_en != '') allProps.name = allProps?.name_en
        else allProps.name_en = allProps.name
        if (allProps?.text_en && allProps.text_en != '') allProps.text = allProps?.text_en
        else allProps.text_en = allProps?.text
        if (allProps?.placeholder_en && allProps.laceholder_en != '') allProps.laceholder = allProps?.laceholder_en
        else allProps.text2_en = allProps?.text2
        if (allProps?.text2_en && allProps.text2_en != '') allProps.text2 = allProps?.text2_en
        else allProps.text3_en = allProps?.text3
        if (allProps?.text3_en && allProps.text3_en != '') allProps.text3 = allProps?.text3_en
        else allProps.text4_en = allProps?.text4
        if (allProps?.text4_en && allProps.text4_en != '') allProps.text4 = allProps?.text4_en
        else allProps.text_en = allProps?.text
        if (allProps?.content_en && allProps.content_en != '') allProps.content = allProps?.content_en
        else allProps.content_en = allProps?.content
        if (allProps?.title_en && allProps.title_en != '') allProps.title = allProps?.title_en
        else allProps.title_en = allProps.title
        if (allProps?.subtitle_en && allProps.subtitle_en != '') allProps.subtitle = allProps?.subtitle_en
        else allProps.subtitle_en = allProps.subtitle
        if (allProps?.tag_en && allProps.tag_en != '') allProps.tag = allProps?.tag_en
        else allProps.tag_en = allProps.tag
        if (allProps?.description_en && allProps.description_en != '') allProps.description = allProps?.description_en
        else allProps.description_en = allProps.description
        if (allProps?.q_en && allProps.q_en != '') allProps.q = allProps?.q_en
        else allProps.q_en = allProps.q
        if (allProps?.a_en && allProps.a_en != '') allProps.a = allProps?.a_en
        else allProps.a_en = allProps.a
        allProps.img = allProps.original.img
        allProps.direction = 'auto'
    }
    if (allProps?.cta) {
        allProps.cta = ctaTransformer(allProps?.cta, i18n)
    }
    if (allProps?.cta2) {
        allProps.cta2 = ctaTransformer(allProps?.cta2, i18n)
    }
    if (allProps?.confirmationMessageCTA) {
        allProps.confirmationMessageCTA = ctaTransformer(allProps?.confirmationMessageCTA, i18n)
    }
    if (allProps?.lottie && googleFiles) {
        const { animationData } = animationTransformer(allProps?.lottie, googleFiles)
        allProps.animationData = animationData
    }
    if (allProps?.form && forms) {
        const { formProps } = formTransformer(allProps?.form, forms)
        allProps.form = formProps
    }
    if (location) {
        const searchParams = locationTransformer(location)
        allProps.searchParams = searchParams?.searchParams
        allProps.location = location
    }
    if (allProps?.img && googleImages) {
        const {
            gatsbyImage,
            gatsbyImageSrc,
            gatsbySeoImage,
            gatsbySeoImageSrc,
            gatsbyTransformed,
            gatsbyTransformedSrc,
            gatsbyImage2,
            gatsbyImage2Src,
            gatsbyTransformed2,
            gatsbyTransformed2Src,
            gatsbyImage3,
            gatsbyImage3Src,
            gatsbyTransformed3,
            gatsbyTransformed3Src,
            gatsbyImage4,
            gatsbyImage4Src,
            gatsbyTransformed4,
            gatsbyTransformed4Src,
        } = imageTransformer(
            allProps?.img,
            allProps?.img2,
            allProps?.img3,
            allProps?.img4,
            allProps?.seoimage,
            googleImages
        )
        allProps.gatsbyImage = gatsbyImage
        allProps.gatsbyImageSrc = gatsbyImageSrc
        allProps.gatsbySeoImage = gatsbySeoImage
        allProps.gatsbySeoImageSrc = gatsbySeoImageSrc
        allProps.gatsbyTransformed = gatsbyTransformed
        allProps.gatsbyTransformedSrc = gatsbyTransformedSrc
        allProps.gatsbyImage2 = gatsbyImage2
        allProps.gatsbyImage2Src = gatsbyImage2Src
        allProps.gatsbyTransformed2 = gatsbyTransformed2
        allProps.gatsbyTransformed2Src = gatsbyTransformed2Src
        allProps.gatsbyImage3 = gatsbyImage3
        allProps.gatsbyImage3Src = gatsbyImage3Src
        allProps.gatsbyTransformed3 = gatsbyTransformed3
        allProps.gatsbyTransformed3Src = gatsbyTransformed3Src
        allProps.gatsbyImage4 = gatsbyImage4
        allProps.gatsbyImage4Src = gatsbyImage4Src
        allProps.gatsbyTransformed4 = gatsbyTransformed4
        allProps.gatsbyTransformed4Src = gatsbyTransformed4Src
        allProps.imageFrame = allProps.imageFrame || true
        allProps.imageMaxWidth = allProps.imageMaxWidth || '512px'
        allProps.imageMaxHeight = allProps.imageMaxHeight || '60px'
        allProps.imageFrame = allProps.imageFrame || true
        allProps.imageStyles = { maxWidth: allProps?.img?.width || '56rem', maxHeight: allProps?.img?.height || 'auto' }
    }

    if (allProps?.icon) {
        const IconReturned = iconTransformer(allProps?.icon)
        // console.log(` ICONTransformed ${IconReturned}`)
        allProps.Icon = IconReturned
    }
    return allProps
}

function ctaTransformer(cta, i18n) {
    if (Array.isArray(cta) && cta?.length == 1) {
        cta = cta[0]
    }
    if (cta && i18n.language === 'ar') {
        cta.text = cta?.text_ar
        cta.label = cta?.label_ar
        cta.placeholder = cta?.placeholder_ar
        cta.name = cta.name_ar
        cta.title = cta.title_ar
        cta.subtitle = cta.subtitle_ar
        cta.description = cta.description_ar
        cta.tag = cta.tag_ar
    }
    return cta
}

function iconTransformer(icon) {
    const Icon1 = ProductIcons[icon]
    const Icon2 = NotProductIcons[icon]
    const Icon3 = OtherIcons[icon]
    const Icon = Icon1 || Icon2 || Icon3
    // console.log(` ICONTransformed ${Icon}`)
    return Icon
}
function seoimageTransformer(googleImages, imageName) {
    const googleImage =
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == imageName) return image
        })[0]
    const googleImage2 =
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == imageName) return image
        })[0]
    const gatsbySeoImage = googleImage && getImage(googleImage)
    const gatsbySeoImage2 = googleImage2 && getImage(googleImage2)
    const gatsbySeoImageSrc = googleImage?.publicURL
    const gatsbySeoImage2Src = googleImage2?.publicURL
    return {
        gatsbySeoImage,
        gatsbySeoImage2,
        gatsbySeoImageSrc,
        gatsbySeoImage2Src,
    }
}
function locationTransformer(location) {
    // const searchParams = new URLSearchParams(location?.search)
    const searchParams = queryString.parse(location?.search)
    return { searchParams }
}
function formTransformer(form, forms) {
    let formProps
    if (forms.name == form) {
        formProps = forms
    }
    return { formProps }
}

function animationTransformer(lottieFileName: string, googleFiles: DownloadedFileNode[]) {
    // Find the matching downloaded file by name
    const file = googleFiles.find(({ name }) => name === lottieFileName)

    if (file && file.fileContent) {
        try {
            // Parse the JSON content to be used directly as animation data
            const animationData = JSON.parse(file.fileContent)
            return {
                animationData,
            }
        } catch (error) {
            console.error(`Error parsing animation data for ${lottieFileName}: ${error}`)
            // Handle parsing error, e.g., return a default animation or log an error
        }
    }

    return { lottieOptions: { animationData: null } }
}

function imageTransformer(img, img2, img3, img4, seoimage, googleImages) {
    const googleImage =
        img &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == img) return image
        })[0]
    const googleImageTransformed =
        img &&
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == img) return image
        })[0]
    const googleImage2 =
        img2 &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == img2) return image
        })[0]
    const googleImageTransformed2 =
        img2 &&
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == img2) return image
        })[0]
    const googleImage3 =
        img3 &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == img3) return image
        })[0]
    const googleImageTransformed3 =
        img3 &&
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == img3) return image
        })[0]
    const googleImage4 =
        img4 &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == img4) return image
        })[0]
    const googleImageTransformed4 =
        img4 &&
        googleImages &&
        googleImages[1] &&
        googleImages[1].filter((image) => {
            if (image.name == img4) return image
        })[0]
    const googleSeoImage =
        seoimage &&
        googleImages &&
        googleImages[0] &&
        googleImages[0].filter((image) => {
            if (image.name == seoimage) return image
        })[0]
    const gatsbyImage = googleImage && getImage(googleImage)
    const gatsbyImageSrc = googleImage?.publicURL
    const gatsbySeoImage = googleSeoImage && getImage(googleSeoImage)
    const gatsbySeoImageSrc = googleSeoImage?.publicURL
    const gatsbyTransformed = googleImageTransformed && getImage(googleImageTransformed)
    const gatsbyTransformedSrc = gatsbyTransformed?.publicURL
    const gatsbyImage2 = googleImage2 && getImage(googleImage2)
    const gatsbyImage2Src = googleImage2?.publicURL
    const gatsbyTransformed2Src = googleImageTransformed2?.publicURL
    const gatsbyTransformed2 = googleImageTransformed2 && getImage(googleImageTransformed2)
    const gatsbyImage3 = googleImage3 && getImage(googleImage3)
    const gatsbyImage3Src = googleImage3?.publicURL
    const gatsbyTransformed3Src = googleImageTransformed3?.publicURL
    const gatsbyTransformed3 = googleImageTransformed3 && getImage(googleImageTransformed3)
    const gatsbyImage4 = googleImage4 && getImage(googleImage4)
    const gatsbyImage4Src = googleImage4?.publicURL
    const gatsbyTransformed4Src = googleImageTransformed4?.publicURL
    const gatsbyTransformed4 = googleImageTransformed4 && getImage(googleImageTransformed4)
    return {
        gatsbyImage,
        gatsbyImageSrc,
        gatsbySeoImage,
        gatsbySeoImageSrc,
        gatsbyTransformed,
        gatsbyTransformedSrc,
        gatsbyImage2,
        gatsbyImage2Src,
        gatsbyTransformed2,
        gatsbyTransformed2Src,
        gatsbyImage3,
        gatsbyImage3Src,
        gatsbyTransformed3,
        gatsbyTransformed3Src,
        gatsbyImage4,
        gatsbyImage4Src,
        gatsbyTransformed4,
        gatsbyTransformed4Src,
    }
}
function PropElementPrepration({ allPropsElement, allPropsKey, reduce, parentKey, targetLang }) {
    const { i18n } = useTranslation()
    let level0TitleProp,
        level1TitleProp,
        level2TitleProp,
        level3TitleProp,
        level4TitleProp = {}
    let level1Prop,
        level2Prop,
        level3Prop,
        level4Prop = []
    let level1PropsArray,
        level2PropsArray = []
    let level1PropKey,
        level2PropKey,
        level3PropKey,
        level4PropKey,
        level0TitlePropKey,
        level1TitlePropKey,
        level2TitlePropKey,
        level3TitlePropKey,
        level4TitlePropKey = ''
    if (allPropsElement) {
        allPropsElement = basicTransformer(allPropsElement, i18n, reduce, targetLang)

        const {
            nextLevelPropsArray,
            nextLevelProp,
            nextLevelPropKey,
            currentLevelTitleProp,
            currentLevelTitlePropKey,
        } = nextLevelPropExtractor(allPropsElement, parentKey)
        level1PropsArray = nextLevelPropsArray
        level1Prop = nextLevelProp
        level1PropKey = nextLevelPropKey
        level0TitleProp = currentLevelTitleProp
        level0TitlePropKey = currentLevelTitlePropKey
        if (level0TitlePropKey != '' && level0TitleProp) {
            level0TitleProp = titlePropTransformer(level0TitleProp, i18n)
            allPropsElement[level0TitlePropKey] = level0TitleProp
        }

        if (Array.isArray(level1PropsArray) && level1PropsArray.length > 0) {
            level1PropsArray.map((level1PropElement, nextLevelPropsArrayIndex) => {
                level1Prop = level1PropElement.nextLevelProp
                level1PropKey = level1PropElement.nextLevelPropKey
                // console.log(`extract level1Prop ${level1PropKey} prop value ${JSON.stringify(level1Prop)} `)
                if (Array.isArray(level1Prop)) {
                    level1Prop = level1Prop.map((level1Element, level1ElementIndex) => {
                        level1Element = basicTransformer(level1Element, i18n, reduce)
                        const {
                            nextLevelPropsArray,
                            nextLevelProp,
                            nextLevelPropKey,
                            currentLevelTitleProp,
                            currentLevelTitlePropKey,
                        } = nextLevelPropExtractor(level1Element)
                        level2PropsArray = nextLevelPropsArray
                        level2Prop = nextLevelProp
                        level2PropKey = nextLevelPropKey
                        level1TitleProp = currentLevelTitleProp
                        level1TitlePropKey = currentLevelTitlePropKey

                        if (level1TitlePropKey != '' && level1TitleProp) {
                            level1TitleProp = titlePropTransformer(level1TitleProp, i18n)
                            level1Element[level1TitlePropKey] = level1TitleProp
                        }
                        // console.log(`level1Prop ${level1PropKey} after Transformation is  ${JSON.stringify(level1Prop)} `)
                        if (Array.isArray(level2PropsArray) && level2PropsArray.length > 0) {
                            level2PropsArray.map((level2PropElement, nextLevelPropsArrayIndex) => {
                                level2Prop = level2PropElement.nextLevelProp
                                level2PropKey = level2PropElement.nextLevelPropKey
                                // console.log(`extract level2Prop ${level2PropKey} prop value ${JSON.stringify(level2Prop)} `)
                                if (Array.isArray(level2Prop)) {
                                    level2Prop = level2Prop.map((level2Element, level2ElementIndex) => {
                                        level2Element = basicTransformer(level2Element, i18n, reduce)
                                        const {
                                            nextLevelProp,
                                            nextLevelPropKey,
                                            currentLevelTitleProp,
                                            currentLevelTitlePropKey,
                                        } = nextLevelPropExtractor(level2Element)
                                        level3Prop = nextLevelProp
                                        level3PropKey = nextLevelPropKey
                                        level2TitlePropKey = currentLevelTitlePropKey
                                        level2TitleProp = currentLevelTitleProp
                                        // console.log(
                                        //     `extract level3Prop ${level3PropKey} prop value ${JSON.stringify(level3Prop)} `
                                        // )
                                        if (level2TitlePropKey != '' && level2TitleProp) {
                                            level2TitleProp = titlePropTransformer(level2TitleProp, i18n)
                                            level2Element[level2TitlePropKey] = level2TitleProp
                                        }
                                        if (Array.isArray(level3Prop)) {
                                            level3Prop = level3Prop?.map((level3Element, level3ElementIndex) => {
                                                level3Element = basicTransformer(level3Element, i18n, reduce)
                                                // console.log(  `extract level3Element ${JSON.stringify(level3Element)} `)
                                                const {
                                                    nextLevelProp,
                                                    nextLevelPropKey,
                                                    currentLevelTitleProp,
                                                    currentLevelTitlePropKey,
                                                } = nextLevelPropExtractor(level3Element)
                                                level4Prop = nextLevelProp
                                                level4PropKey = nextLevelPropKey
                                                level3TitlePropKey = currentLevelTitlePropKey
                                                level3TitleProp = currentLevelTitleProp
                                                // console.log(
                                                //     `extract level4Prop ${level4PropKey} prop value ${JSON.stringify(
                                                //         level4Prop
                                                //     )} `
                                                // )
                                                if (level3TitlePropKey != '' && level3TitleProp) {
                                                    level3TitleProp = titlePropTransformer(level3TitleProp, i18n)
                                                    level3Element[level3TitlePropKey] = level3TitleProp
                                                }
                                                if (Array.isArray(level4Prop)) {
                                                    level4Prop = level4Prop.map((level4Element, level4ElementIndex) => {
                                                        level3Element = basicTransformer(level4Element, i18n, reduce)
                                                        const {
                                                            nextLevelProp,
                                                            nextLevelPropKey,
                                                            currentLevelTitleProp,
                                                            currentLevelTitlePropKey,
                                                        } = nextLevelPropExtractor(level4Element)
                                                        level5Prop = nextLevelProp
                                                        level5PropKey = nextLevelPropKey
                                                        level4TitlePropKey = currentLevelTitlePropKey
                                                        level4TitleProp = currentLevelTitleProp
                                                        if (level4TitlePropKey != '' && level4TitleProp) {
                                                            level4TitleProp = titlePropTransformer(
                                                                level4TitleProp,
                                                                i18n
                                                            )
                                                            level4Element[level4TitlePropKey] = level4TitleProp
                                                        }

                                                        return level4Element
                                                    })
                                                }
                                                if (level4Prop && level4PropKey != '') {
                                                    if (Array.isArray(level3Element)) {
                                                        level3Element.push({ [level4PropKey]: level4Prop })
                                                    } else {
                                                        level3Element[level4PropKey] = level4Prop
                                                    }
                                                }

                                                return level3Element
                                            })
                                        }
                                        if (level3Prop && level3PropKey != '') {
                                            if (Array.isArray(level2Element)) {
                                                level2Element.push({ [level3PropKey]: level3Prop })
                                            } else {
                                                level2Element[level3PropKey] = level3Prop
                                            }
                                        }

                                        return level2Element
                                    })
                                }
                                if (level2Prop && level2PropKey != '') {
                                    if (Array.isArray(level1Element)) {
                                        level1Element.push({ [level2PropKey]: level2Prop })
                                    } else {
                                        level1Element[level2PropKey] = level2Prop
                                    }
                                }
                            })
                        }
                        return level1Element
                    })
                }

                if (level1Prop && level1PropKey != '') {
                    if (Array.isArray(allPropsElement)) {
                        allPropsElement.push({ [level1PropKey]: level1Prop })
                    } else {
                        allPropsElement[level1PropKey] = level1Prop
                    }
                }
            })
        }
    }
    return allPropsElement
}

export function getSeoImage(props) {
    googleImages = props?.googleImages
    const imageName = props?.imageName || 'seoimage'
    let gatsbySeoImageSrc = null
    if (googleImages) {
        gatsbySeoImageSrc = seoimageTransformer(googleImages, imageName)?.gatsbySeoImageSrc
    }
    return gatsbySeoImageSrc
}
export function getSeoGatsbyImage(props) {
    googleImages = props?.googleImages
    const imageName = props?.imageName || 'seoimage'
    let gatsbySeoImage = null
    if (googleImages) {
        gatsbySeoImage = seoimageTransformer(googleImages, imageName)?.gatsbySeoImage2
    }
    return gatsbySeoImage
}

export function prepareData({ props, reduce = false, parentKey, targetLang }) {
    let allProps = {}
    let allPropsKey = ''
    googleImages =
        props?.googleImages ||
        (props?.data?.pageData?.parent?.images || props?.data?.pageData?.parent?.images2
            ? [props?.data?.pageData?.parent?.images, props?.data?.pageData?.parent?.images2]
            : [props?.data?.pageData?.nodes?.[0].parent?.images || props?.data?.pageData?.nodes?.[0].parent?.images2])
    googleFiles =
        props?.data?.pageData?.parent?.downloadedFiles || props?.data?.pageData?.nodes?.[0].parent?.downloadedFiles
    forms = props?.data?.pageData?.parent?.forms
    location = props?.location
    tutorials = props?.data?.tutorialsPosts?.edges
    tutorialsRecent = props?.data?.tutorialsRecent?.edges
    tutorialsCategories = props?.data?.tutorialsCategories
    tutorialsPopular = props?.data?.tutorialsPopular
    blogs = props?.data?.blogPosts?.edges
    customers = props?.data?.customersPosts
    documentations = props?.data?.documentationPosts
    if (props) {
        for (const key of Object.keys(props)) {
            if (key.startsWith(`all`)) {
                allProps = props[key]
                allPropsKey = key
            }
        }
    }
    // console.log(`extract allPropsKey ${allPropsKey} prop value ${JSON.stringify(allProps)} length ${allProps.length} `)
    if (Array.isArray(allProps) && allProps.length > 1) {
        allProps.map((allPropsElement, index) => {
            const allPropsElementResult = PropElementPrepration({
                allPropsElement,
                allPropsKey,
                reduce,
                parentKey,
                targetLang,
            })
            allProps[index] = allPropsElementResult
        })
    } else if (allProps) {
        const allPropsElement = allProps
        const allPropsElementResult = PropElementPrepration({
            allPropsElement,
            allPropsKey,
            reduce,
            parentKey,
            targetLang,
        })
        allProps = allPropsElementResult
    }
    return { ...allProps }
}
